module.exports = __webpack_public_path__ + "media/images/user/favicons/site-tile-310x150-d9ebd309fc3557ebbaa6dc610f440c83.png";